import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import { useTheme } from "../lib/use-theme";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation("common");
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={t("topbar.theme")}
    >
      {theme === "light" ? <Moon /> : <Sun />}
    </Button>
  );
}
